export var TypeActionEnvSelect;
(function (TypeActionEnvSelect) {
    TypeActionEnvSelect["Select"] = "EnvSelect > Select";
})(TypeActionEnvSelect || (TypeActionEnvSelect = {}));
export var actionEnvSelect = function (environment) { return ({
    environment: environment,
    type: TypeActionEnvSelect.Select,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/env-select/actionEnvSelect.ts
// module id = 340
// module chunks = 3